module.exports = __webpack_public_path__ + "static/media/FREE_RETURNS_60X50.c1876396.svg";